import React from "react";
import DataTable from "../../Components/DataTable/DataTable";
import {
	alertBox,
	getStatusColor,
	noAvatar,
	toMoney,
} from "../../Components/Functions";
import { loggedUser } from "../../Constants/menus";
import { routers } from "../../Constants/routers";
import Api from "../../Server/Api";
import { PaymentButton } from "../patient/PaymentButton";


const api = new Api();

export const RenderItem = ({ item }) => {


	return (
		<>
		<td>{item?.note} {item?.payment_mode}</td>
		<td>{item?.date_time}</td>
		<td>
		<span
			className={`tag is-${item?.type === "CREDIT" ? "success":"danger"}`}
		>
			{item?.type}
		</span>
		</td>
		<td className={` text-${item?.type === "CREDIT" ? "success":"danger"}`} >{toMoney(item?.amount)}</td>
		<td>{toMoney(item?.receiver_new_balance)}</td>
		<td>
		<span
			className={`tag is-${getStatusColor( item?.status )}`}
		>
			{item?.status}
		</span>
		</td>
		
	</>
	);
};

const Transactions = ({ title="Transaction List", is_patient }) => {
	// const [] = React.useState([]);

	const renderItem = (item) => {
		return <RenderItem item={item} />;
	};
	return (
		<>
		<div className="column is-12">
			{/*Header*/}
			<div className="table-header" style={{ marginTop: 0 }}>
				<h3 className="dark-inverted">{title}</h3>
			</div>

		
				{/*Table item*/}


		</div>
				<DataTable
					// header={[]}
					header={[
						{
							name: "Description",
						},
						{
							name: "Date",
						},
						{
							name: "Type",
						},
						{
							name: "Amount",
						},
						{
							name: "Balance",
						},
						{
							name: "Status",
						},
					]}
					options={{
						allowRemove: false,
						allowBulkSelect: false,
						disableToolBar: true,
						disablePagination: false,
						// disableSearch: true,
						removeEndPoint: "",
						endpoint: {
							url: `/users/${loggedUser?.username}/transactions/`,
							params: {
								statuses: is_patient ? ["PENDING", "SUCCESS"] : ["PENDING", "SUCCESS"],
							},
						},
						left: [],
						right: [],
					}}
					// trClassName="order-table-item"
					renderItem={renderItem}
				/>
				</>
	);
};

export default Transactions;
